export const DefinitionsActionTypes = {
  SET_BUSES: 'SET_BUSES',
  SET_EXCEL_DATA: 'SET_EXCEL_DATA',
  SET_DRIVERS: 'SET_DRIVERS',
  SET_USERS: 'SET_USERS',
  SET_SCHEDULES: 'SET_SCHEDULES',
  SET_BUSROUTES: 'SET_BUSROUTES',
  SET_ROUTEBUSDRIVERS: 'SET_ROUTEBUSDRIVERS'
}